<template>
  <Popover :title="title" ref="popover" @show="onPopoverShow" @hide="onPopoverHide">
    <span>设置起量状态&ensp;</span>
    <el-button type="text" @click="confirm">关闭一键起量</el-button>

    <el-button slot="ref" type="text">
      <slot></slot>
    </el-button>
  </Popover>
</template>

<script>
import Popover from '@/components/popover/index.vue'

export default {
  components: { Popover },
  props: {
    value: [Number, String],
    title: String
  },
  data() {
    return {}
  },
  methods: {
    confirm() {
      this.$emit('input', 0)
      this.$refs.popover.close()
    },
    onPopoverShow() {},
    onPopoverHide() {}
  }
}
</script>

<style lang="scss" scoped>
</style>
